import React, { useState } from 'react';
import PlusCircle from '@components/Icons/PlusCircle';

import AddExemptionsModal, { AddExemptionsFormData } from './AddExemptionsModal';
import Button from '../DesignLibrary/Button';
import s from './AddExemptions.module.scss';
import ExemptionLimitsModal from './ExemptionLimitsModal';

interface AddExemptionsProps {
  value: AddExemptionsFormData[];
  onChange: (exemptions: AddExemptionsFormData[]) => void;
}

const AddExemptions: React.FC<AddExemptionsProps> = ({ value, onChange }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLimitsModalOpen, setIsLimitsModalOpen] = useState(false);

  // Transform value to ExemptionLimitRow[] for the modal
  const exemptionLimitRows = value?.map((item) => ({
    available: item.amount ? `$${Number(item.amount).toLocaleString()}` : '',
    description: item.description || '',
    status: 'Available',
    statusColor: 'green' as const,
    statute: item.exemptionLaws || '',
    totalLimit: item.amount ? `$${Number(item.amount).toLocaleString()}` : '',
    used: '$0',
  }));

  const handleAddExemption = (): void => {
    setIsModalOpen(true);
  };

  const handleSave = (data: AddExemptionsFormData): void => {
    const existingValue = Array.isArray(value) ? value : [];
    const newList = [...existingValue, data];
    onChange(newList);
    setIsModalOpen(false);
  };

  return (
    <div className={s.exemptionsRoot}>
      <h4 className={s.exemptionsHeading}>Exemptions Claimed</h4>
      <div>
        {!value || value?.length === 0
          ? (
            <div className={s.exemptionsEmpty}>No exemptions claimed yet</div>
          )
          : (
            <ul className={s.exemptionsListContainer}>
              {value.map((ex, idx) => (
                <li className={s.exemptionItem} key={idx}>
                  <div>
                    <p className="caption-bold">{ex.exemptionClaim}</p>
                    <p className="caption">{ex.exemptionLaws}</p>
                  </div>
                  <div className="caption">
                  ${Number(ex.amount).toLocaleString()}
                  </div>
                </li>
              ))}
            </ul>
          )}
      </div>
      <div className={s.exemptionsBtnWrapper}>
        <Button variant="primary" size="sm" onClick={handleAddExemption}>
          <PlusCircle weight='fill' style={{ marginRight: 8 }} /> Add Another Exemption
        </Button>
        <Button variant="secondary" size="sm" onClick={() => setIsLimitsModalOpen(true)}>
          View Exemptions Limits
        </Button>
      </div>
      <AddExemptionsModal open={isModalOpen} onClose={() => setIsModalOpen(false)} onSave={handleSave} />
      <ExemptionLimitsModal open={isLimitsModalOpen} onClose={() => setIsLimitsModalOpen(false)} data={exemptionLimitRows} />
    </div>
  );
};

export default AddExemptions;
